var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNovaLogoStripped = function SvgNovaLogoStripped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.7,
    strokeWidth: 0.5,
    d: "M19.998 5.43c0-.562-.367-1.06-.912-1.236l-6.497-2.101a1.92 1.92 0 0 0-1.18 0L4.912 4.194A1.3 1.3 0 0 0 4 5.43v13.14c0 .562.368 1.06.913 1.236l6.497 2.101c.383.124.797.124 1.18 0l6.497-2.101c.545-.176.913-.674.913-1.236V5.43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.85,
    d: "m12.288 5.357 1.184 4.944a.37.37 0 0 0 .263.266l4.396 1.153a.287.287 0 0 1 0 .557l-4.396 1.152a.36.36 0 0 0-.263.267l-1.184 4.943c-.07.297-.504.297-.574 0l-1.184-4.943a.37.37 0 0 0-.262-.267L5.87 12.277a.287.287 0 0 1 0-.557l4.397-1.153a.36.36 0 0 0 .262-.266l1.184-4.944c.07-.296.504-.296.574 0"
  })));
};
export default SvgNovaLogoStripped;